import React, { Component } from 'react'
import { Link } from 'react-router'
import onClickOutside from 'react-onclickoutside-decorator'
import { Icon } from '@driftt/tide-core-legacy'
import ACCESS from 'utils/Access'
import { helpUtils } from '@driftt/integrated-help-launcher'
import { SUPPORT_TICKET_INTERACTION_ID, HELP_URL, FREE_USER_INTEGRATED_HELP_INTERACTION_ID, PAID_USER_INTEGRATED_HELP_INTERACTION_ID } from 'constants/ResourcesConstants'

class HelpFlyout extends Component {

  componentDidMount() {
    this.props.trackHelpFlyout({ eventType: 'viewed' })
  }

  triggerTicketPlaybook = () => {
    window.drift.api.startInteraction({ interactionId: SUPPORT_TICKET_INTERACTION_ID })
  }
  triggerFreeIntegratedHelp = () => {
    window.drift.api.startInteraction({ interactionId: PAID_USER_INTEGRATED_HELP_INTERACTION_ID })
  }

  triggerPaidIntegratedHelp = () => {
    window.drift.api.startInteraction({ interactionId: PAID_USER_INTEGRATED_HELP_INTERACTION_ID })
  }

  triggerIntegratedHelp = () => {
    if (helpUtils.shouldLaunchHelpInteraction()) {
      const isPaidUser = ACCESS.hasGates('premium_drift')
      isPaidUser ? this.triggerPaidIntegratedHelp() : this.triggerFreeIntegratedHelp()
      helpUtils.saveHelpInteractionStart()
    } else {
      window.drift.api.openChat()
    }
  }

  handleChatWidget = () => {
    return (
      <div className="help-flyout-option-item">
        <Icon className="help-options-question-icon" name="comments-1" />
        <span onClick={() => {
          this.triggerIntegratedHelp()
          return this.handleLinkTracking('chat-widget', 'open chat widget', 'Chat with us')
        }} >Chat with us</span>
      </div>
    )
  }

  handleLinkTracking = (key, cta, text) => {
    this.props.trackHelpFlyout({ eventType: 'clicked', ctaInfo: { key: key, type: 'link', CTA: cta, text: text } })
    return true
  }

  render() {

    return (
      <div className="help-flyout">
        <h3>How can we help?</h3>

        <div className="help-flyout-options">
          <nav>
            <div className="help-flyout-option-item">
              <Icon className="help-options-window-icon" name="window-search" />
              <a href={HELP_URL} target="_blank" onClick={() => {
                return this.handleLinkTracking('help-center', 'trigger help center', 'Search our Help Center')
              }}>Search our Help Center</a>
            </div>

            <div className="help-flyout-option-item">
              <Icon className="help-options-lightning-icon" name="lightning-bolt" />
              <a href="https://insider.drift.com/classes" target="_blank" onClick={() => {
                return this.handleLinkTracking('webinar-page', 'trigger drift insider classes page', 'Find a Training')
              }}>Find a Training</a>
            </div>

            {ACCESS.hasPaidGates() && this.handleChatWidget()}

            {ACCESS.isAdmin() && <div className="help-flyout-option-item">
              <Icon className="help-options-comments-icon" name="question-bubble" />
              <span onClick={() => {
                this.triggerTicketPlaybook()
                return this.handleLinkTracking('help-request-submit', 'trigger ticket playbook', 'Submit a help request')
              }} >Submit a help request</span>
            </div>}

            {ACCESS.isAdmin() &&
              <div className="help-flyout-option-item">
                <Icon className="help-options-support-icon" name="support-ticket" /> <a href="/settings2/help" onClick={() => {
                  return this.handleLinkTracking('help-request-page', 'trigger support requests page', 'View your help requests')
                }}>View your help requests</a>
              </div>}

            <div className="help-flyout-option-item">
              <Icon height={16} width={16} name="notification" />
              <a href="https://drift.status.io" target="_blank" rel='noreferrer noopener' onClick={() => {
                  return this.handleLinkTracking('check-status-page', 'trigger status check page', `Check out Drift's status`)
              }}>Check out Drift's status</a>
            </div>

          </nav>
        </div>
      </div>
    )
  }
}

export default onClickOutside(HelpFlyout)



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/Help/Popover/index.js